import { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import useAuth from '@hooks/useAuth';
import { PATH_ETF } from '@routes/paths';
import { Permission } from './permissions';
import useCan from './useCan';

type RequirePermissionProps = {
  permission: Permission | Permission[];
  children: ReactNode;
};

/**
 * 라우트 가드. 권한이 없으면 첫 화면(`/etf`)으로 보낸다.
 *
 * 인증 초기화가 끝나기 전에는 아무것도 그리지 않는다. 그러지 않으면 권한이 채워지기
 * 전 한 프레임 동안 권한 없음으로 판정돼 정상 사용자가 튕긴다.
 */
export default function RequirePermission({
  permission,
  children,
}: RequirePermissionProps): ReactElement | null {
  const { isInitialized } = useAuth();
  const can = useCan();
  const required = Array.isArray(permission) ? permission : [permission];

  if (!isInitialized) return null;
  if (!can(...required)) return <Navigate to={PATH_ETF.root} replace />;

  return <>{children}</>;
}
